import { toast } from "react-hot-toast";
import { actionType } from "../utils/helpers/generalHelper";
import * as AnnouncementConstants from "../constants/announcement.constant";
import AnnouncementService from "../services/announcement.service";
import ErrorHelper from "../utils/helpers/errorHelper";

export const createAnnouncement = (payload) => async (dispatch) => {
  try {
    dispatch(actionType(AnnouncementConstants.CREATE_ANNOUNCEMENT_REQUEST));
    const data = await AnnouncementService.create(payload);
    if (data === undefined || data.status !== 201) {
      throw data;
    }
    dispatch(
      actionType(AnnouncementConstants.CREATE_ANNOUNCEMENT_SUCCESS, data.data)
    );
    dispatch(fetchAnnouncements());
  } catch (error) {
    let message = ErrorHelper.getApiErrorMessage(error);
    dispatch(actionType(AnnouncementConstants.CREATE_ANNOUNCEMENT_FAILURE));
    toast.error(message);
  }
};

export const fetchAnnouncements = (pageAble) => async (dispatch) => {
  try {
    dispatch(actionType(AnnouncementConstants.FETCH_ALL_ANNOUNCEMENT_REQUEST));
    const data = await AnnouncementService.fetchAll(pageAble);
    if (data === undefined || data.status !== 200) {
      throw data;
    }
    dispatch(
      actionType(
        AnnouncementConstants.FETCH_ALL_ANNOUNCEMENT_SUCCESS,
        data.data
      )
    );
  } catch (error) {
    let message = ErrorHelper.getApiErrorMessage(error);
    dispatch(actionType(AnnouncementConstants.FETCH_ALL_ANNOUNCEMENT_FAILURE));
    toast.error(message);
  }
};

export const fetchAnnouncement = (pageAble, id) => async (dispatch) => {
  try {
    dispatch(actionType(AnnouncementConstants.FETCH_ANNOUNCEMENT_REQUEST));
    const data = await AnnouncementService.fetchById(pageAble, id);
    if (data === undefined || data.status !== 200) {
      throw data;
    }
    dispatch(
      actionType(AnnouncementConstants.FETCH_ANNOUNCEMENT_SUCCESS, data.data)
    );
  } catch (error) {
    let message = ErrorHelper.getApiErrorMessage(error);
    dispatch(actionType(AnnouncementConstants.FETCH_ANNOUNCEMENT_FAILURE));
    toast.error(message);
  }
};

export const deleteAnnouncement = (payload) => async (dispatch) => {
  const { id, action } = payload;
  try {
    dispatch(
      actionType(AnnouncementConstants.DELETE_ANNOUNCEMENT_REQUEST, {
        loading: true,
        id,
      })
    );
    const data = await AnnouncementService.delete(id);
    if (data === undefined || data.status !== 200) {
      throw data;
    }
    dispatch(
      actionType(AnnouncementConstants.DELETE_ANNOUNCEMENT_SUCCESS, {
        loading: false,
        id,
      })
    );
    toast.success(`Announcement ${action}d successfully.`);
  } catch (error) {
    let message = ErrorHelper.getApiErrorMessage(error);
    dispatch(
      actionType(AnnouncementConstants.DELETE_ANNOUNCEMENT_FAILURE, {
        loading: false,
        id,
      })
    );
    toast.error(message);
  }
};

export const updateAnnouncement = (payload) => async (dispatch) => {
  const { id, action } = payload;
  try {
    dispatch(
      actionType(AnnouncementConstants.UPDATE_ANNOUNCEMENT_REQUEST, {
        loading: true,
        id,
      })
    );
    const data = await AnnouncementService.update(id);
    if (data === undefined || data.status !== 200) {
      throw data;
    }
    dispatch(
      actionType(AnnouncementConstants.UPDATE_ANNOUNCEMENT_SUCCESS, {
        loading: false,
        id,
      })
    );
    toast.success(`Announcement ${action}d successfully.`);
  } catch (error) {
    let message = ErrorHelper.getApiErrorMessage(error);
    dispatch(actionType(AnnouncementConstants.UPDATE_ANNOUNCEMENT_FAILURE), {
      loading: false,
      id,
    });
    toast.error(message);
  }
};

export const getApproval = (payload) => async (dispatch) => {
  const { id, action } = payload;
  try {
    dispatch(
      actionType(AnnouncementConstants.ANNOUNCEMENT_APPROVAL_REQUEST, {
        loading: true,
        id,
      })
    );
    const data = await AnnouncementService.approveOrDisapprove(payload);
    if (data === undefined || data.status !== 200) {
      throw data;
    }
    dispatch(
      actionType(AnnouncementConstants.ANNOUNCEMENT_APPROVAL_SUCCESS, {
        loading: false,
        id,
      })
    );
    toast.success(
      `Announcement ${
        action === "approve" ? "published" : action
      } successfully.`
    );
  } catch (error) {
    let message = ErrorHelper.getApiErrorMessage(error);
    dispatch(actionType(AnnouncementConstants.ANNOUNCEMENT_APPROVAL_FAILURE), {
      loading: false,
      id,
    });
    toast.error(message);
  }
};
